import { gql } from "@apollo/client";

export const GENERATE_WAREHOUSE_LOCATION_QR_CODE_PDF = gql`
    mutation GenerateWarehouseLocationQrCodePdf($locationIds: [Long!]!, $language: String) {
        generateWarehouseLocationBatchQrCodePdf(locationIds: $locationIds, language: $language)
    }
`;

export interface GenerateWarehouseLocationQrCodePdfResponse {
    generateWarehouseLocationBatchQrCodePdf: string;
}

